import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
var _excluded = ["to", "className"];
import React from 'react';
import { Link } from 'gatsby';
import { ChildrenPropType } from '../../services/proptypes';

var InternalLink = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(InternalLink, _React$Component);

  function InternalLink() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = InternalLink.prototype;

  _proto.createContainerProps = function createContainerProps() {
    var _this$props = this.props,
        to = _this$props.to,
        className = _this$props.className,
        rest = _objectWithoutPropertiesLoose(_this$props, _excluded);

    return _extends({
      to: to,
      className: className,
      activeStyle: {
        textDecoration: 'underline',
        textUnderlinePosition: 'under'
      }
    }, rest);
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        label = _this$props2.label,
        children = _this$props2.children;
    return /*#__PURE__*/React.createElement(Link, this.createContainerProps(), children || label);
  };

  return InternalLink;
}(React.Component);

export { InternalLink as default };
InternalLink.defaultProps = {
  label: '',
  className: '',
  children: null
};